

export const PermissionPages = {
    // Permissions for the application
    Admin: {
        ResetClubRequirements: "0bfff62f-3d60-4feb-be29-a972b0ecf752",
        Analysis: "7e363732-f65c-4dfa-a06b-f648ffdbffde",
    },
    Player: {
        PlayerAdmin: "e599ef6a-121c-4144-b8f6-30c3203b36f2",
        PlayerAdd: "079d6192-6fbe-4dc5-96f2-141ccef9d84a",
        PlayerSearch: "4046f9f5-277d-43bb-88f5-8b4f91db732f",
        StellarContacts: "8357d8e6-6ecb-4b1d-b667-f5133a1b3a48",
        TopSection: "9f13bb73-e3f3-4705-9ea0-d2937f4b665b",
        PlayerDetailsKeyContacts: "26fb4c2b-b554-42af-a7dc-de7dc2bdf635",
        RepresentationContract: "592f3fe8-9ccd-48d7-b030-638f4fc4d6e3",
        ClubContract: "556412ba-45a6-48b3-9b1e-11daa6884a8d",
        PlayerInfo: "f71ab7e1-dcf8-4ceb-a6db-53ed6b3ac923",
        Comments: "b475d9a2-e2f7-408b-b93b-9064ae8ae9b1",
        ClubDetails: "1241c960-c626-4b4a-aaa6-cf05f84ed31d",
        PlayerFiles: "7ac0d40d-aeca-4017-bde2-65abc6561129",
    },
    Club: {
        ClubAdd: "0db0400c-2eb1-471d-a0f6-a04f5081f58f",
        ClubSearch: "f2160a45-abb2-4718-8b68-5a154868e4a9",
        MatchReports: "69598272-f03c-4f9b-af31-74d524d70023",
        TransferSheets: "891593a6-b8c7-4b64-a5e6-421b16c65eb7",
        Requirements: "180efba1-bd4f-41c1-a15b-588bc52b5d99",
        RequirementsChangeCreatedBy: "1aca7c04-abdb-4bef-9d65-a98136b1ed8d",
        ClubStaff: "ced10b35-f328-46e9-9f26-d455404522e7",
        ClubDetails: "a7df8448-0e0e-4250-92c5-1b6e5321858e",
        ClubFiles: "56199ab6-dd99-4859-a22f-fa551d1bee10",
        StellarContacts: "42d10528-f3e4-41d7-9e88-858f04d6064c",
        // League Manager (Clubs -> League Manager).
        LeagueManager: "d47e7ce3-5299-4f9e-aceb-bc6b1980ea25",
    },
};

export const PlayerStatuses = {
    Client: "E45D7BB6-EFB7-4DAC-8CA1-84138800FBF9",
    LeftUs: "783742EF-2B15-4F11-87A1-2B2341A41F20",
    Prospect: "0444F577-2B3B-4958-BE24-92B0132415BD",
    Highlighted: "80F07A4C-F873-44F0-B21C-20CA8CDCE0B8",
    OldHighlighted: "836A3FEC-5DCF-4469-90CB-34DABA7DE615",
    Retired: "E74E45FC-64D5-4926-9D2B-A2D693B2EED2",
    OldProspect: "FC9899E3-0C92-4200-BE65-B17DDDF0493C",
};

export const StatusOmitValues = [
    {
        roleName: "Super Admin",
        omit: [],
    },
    {
        roleName: "Admin",
        omit: [],
    },
    {
        roleName: "Scout",
        omit: [
            PlayerStatuses.Client,
            PlayerStatuses.LeftUs,
            PlayerStatuses.Retired,
            PlayerStatuses.OldProspect,
            PlayerStatuses.OldHighlighted,
        ],
    },
    {
        roleName: "Agent",
        omit: [
            PlayerStatuses.Client,
            PlayerStatuses.LeftUs,
            PlayerStatuses.Retired,
            PlayerStatuses.OldProspect,
            PlayerStatuses.Highlighted,
            PlayerStatuses.OldHighlighted,
        ],
    },
    {
        roleName: "Management",
        omit: [
            PlayerStatuses.Client,
            PlayerStatuses.LeftUs,
            PlayerStatuses.Retired,
            PlayerStatuses.OldProspect,
            PlayerStatuses.Highlighted,
            PlayerStatuses.OldHighlighted,
        ],
    },
];

export const getStatusOmitValues = () => {
    var roleName = localStorage.getItem("userRole");
    const role = StatusOmitValues.find((r) => r.roleName === roleName);
    return role ? role.omit : [];
};